import Swal from 'sweetalert2'

export async function useDeleteAlert(options) {
	const title = options?.title || 'DESEJA MESMO DELETAR ESTE(S) ITEM(NS)?'
	const html = options?.html || 'DIGITE "DEL" NO CAMPO ABAIXO'
	const errorMessage =
		options?.errorMessage || 'ESCREVA "DEL" PARA CONFIRMAR.'

	return Swal.fire({
		customClass: {
			container: 'themed delete',
		},
		title,
		html,
		input: 'text',
		inputPlaceholder: 'DEL',
		inputValidator: value => {
			if (value.trim().toLowerCase() !== 'del') {
				return errorMessage
			}
		},
		showCancelButton: true,
		reverseButtons: true,
		confirmButtonText: 'SIM',
		cancelButtonText: 'NÃO',
	})
}
